import React from 'react';
import RestInputItem from '../../../../components/RestInput/RestInputItem';

const LeadersForm = props => (
  <div {...props}>
    <RestInputItem source="displayName" header="leaders.displayName" />
  </div>
);

LeadersForm.propTypes = {};

export default LeadersForm;
